import React from 'react';
import {
    Row, Col, Card, CardBody, Progress, ModalBody, Modal, ModalHeader, Button, ModalFooter
} from 'reactstrap';
import NotificationSystem from 'react-notification-system';

import {connect} from "react-redux";
import {alertActions, commonActions, modalActions} from "../../_actions";
import {alertConstants, appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";

import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import ComponentPageError from "../utils/component-page.error";

import {appHelpers, store} from "../../_helpers";
import InvoiceTimeline from "./timeline";
import InvoiceSearchPanel from "./invoice-search-panel";
import PageEmptyContent from "../utils/page.empty-content";
import {commonService} from "../../_services";
import moment from "moment/moment";

//icons
import CheckIcon from 'react-icons/lib/md/info';
import ReportIcon from 'react-icons/lib/md/airplanemode-active';

import InvoiceIssuerTable from "./invoice-issuer-table";
import DownloadIcon from 'react-icons/lib/md/cloud-download';

const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class InvoiceReconciliationViewContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reports: [],
            TotalCount: 0,
            airlines: [],
            modal: false,
            generateInvoiceModal: false,
            issuerInvoiceModal: false,
            modalClass: '',
            //Filter form
            processDate: false,
            filterModes: [
                {
                    id: 1,
                    name: 'Airline'
                },
                {
                    id: 2,
                    name: 'Invoice Status'
                },
                {
                    id: 3,
                    name: 'Currency'
                },
                {
                    id: 4,
                    name: 'Process File'
                }
            ],
            currentFilterParameter: [],
            selectedFilterMode: 1,
            filterOptions: [],
            filterValues: [],
            filterValueKey: '',
            filterLabelKey: '',

            //page error
            contentError: false,  //Errors that affect content on the page
            componentErrorMessages: [],  //Errors generated within the component form
            componentError: false,
            error: false,
            invoiceError: false,
            success: false,
            positionFromBottom: 0,
            //Filter options
            statusFilterTypeOptions: [{Id: 'SF1', Name:'Invoiced', type: 2}, {Id: 'SF2', Name:'Not Invoiced', type: 2}],
            currencyFilterTypeOptions: [{Id: 'CF1', Name:'Naira', Code: 566, type: 3}, {Id: 'CF2', Name:'Dollars', Code: 840, type: 3}],
            //    Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },

            invoiceIssuer: [],
            //pagination params
            pageSize: 10,
            currentPage: 1,
            billSummaryId: null,
            formPayload: [],
            //  Page mode to cater for Search & Process Breakdown
            pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE,
            activeBillSummaryField: null,
            billsByProcessRecords: [],
            invoiceReconciliationFiles: []
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let {airlinesCarriers} = reduxState;
        if(airlinesCarriers){
            this.setState({airlines: airlinesCarriers.Results, filterOptions: airlinesCarriers.Results})
        }else{
            this.fetchAirlines();
        }

        this.setState({ reports: [], filterLabelKey: 'Id', filterValueKey: 'Name'});
        this.search();

        //    Fetch Reconciliation files
        this.getInvoiceReconciliationFiles();
        window.addEventListener('scroll', this.onScroll, false);
        this.onScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll, false);
    }

    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        const { modal } = nextProps;

        if(alert){
            if(alert.type === alertConstants.SUCCESS ) {
                this.setState({error: false, success: 'Operation successful'});
                this.resetForm();
            }
            else if(alert.type === alertConstants.CLEAR ){
                this.setState({success: false, error: false})

            }else{
                this.setState({success: false, error: alert.message})
            }
        }
        if(modal){
            if(modal.type === appConstants.OPEN_MODAL ){
                this.setState({
                    modal: true,
                    modalClass: modal.modalClass
                })
            }else if(modal.type === appConstants.CLOSE_MODAL){
                this.setState({
                    modal: false,
                    modalClass: modal.modalClass
                });
                this.resetForm();
            }
        }
    };

    handleChange = (event, attribute) => {
        let currState = this.state;
        currState[attribute] = event.target.value;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState(currState);
        this.setState({componentErrorMessages: errorMessages});
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if(this.state.airlineName === ''){
            _errs_['airlineName'] = 'Please enter airline name';
            formValid = false;
        }
        if(this.state.shortName === ''){
            _errs_['shortName'] = 'Please enter short name';
            formValid = false;
        }
        if(this.state.airlineCode === '') {
            _errs_['airlineCode'] = 'Please enter airline name';
            formValid = false;
        }
        if(this.state.aviationCode === ''){
            _errs_['aviationCode'] = 'Please enter aviation name';
            formValid = false;
        }
        if(this.state.airlineCode === '') {
            _errs_['airlineCode'] = 'Please enter airline code';
            formValid = false;
        }
        if(this.state.ticketFormat === ''){
            _errs_['ticketFormat'] = 'Please enter ticket format';
            formValid = false;
        }
        if(this.state.sisId === ''){
            _errs_['sisId'] = 'Please enter SSID';
            formValid = false;
        }
        this.setState({componentErrorMessages: _errs_});
        return formValid;
    };

    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    resetForm() {
        this.setState({invoiceError: false, componentError: false, componentErrorMessages: [], airlineId: false, airlineName: '', shortName: '', aviationCode: '', airlineCode: '', ticketFormat: '', sisId: '', IsLocal: false, carrier: false});
        this.resetError();
    }

    handleSubmit  = (event) => {
        event.preventDefault();
        this.setState({isRequesting: true});
        this.resetError();
        if(this.validateInput()){
            this.processSubmit();
        }
    };

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }
    toggle = (e, modalClass) => {
        if(this.state.modal){
            this.resetForm();
            this.props.dispatch(modalActions.close({'modalClass': modalClass}));
        }else{
            this.props.dispatch(modalActions.open({'modalClass': modalClass}));
        }
    };

    toggleCheckbox = (attribute) => {
        let currState = this.state;
        currState[attribute] = !currState[attribute];
        this.setState(currState);
    };

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    fetchAirlines = () => {
        this.setState({contentError: false});
        const {dispatch} = this.props;
        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                let {airlinesCarriers} = this.props;
                this.setState({airlines: airlinesCarriers.Results, filterOptions: airlinesCarriers.Results });
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
        });
    };
    search = (pageNumber) => {
        this.resetError();
        const pageNumberLock = pageNumber;
        const { filterValues, processDate, pageSize, pageMode, billsByProcessRecords } = this.state;

        let  airlineCode, invoiceStatus, currency  = false;
        filterValues.map((item) => {
            if(item.type === 2){
                invoiceStatus = item.Name;
            }else if(item.type === 3){
                //    Currency selected selected
                currency = item.Code;
            }else if(item.type === undefined){
                //    Airline selected
                airlineCode = item.Code;
            }
            return true;
        });
        let parameter = {};
        if(processDate){
            parameter.InvoiceMonth =  moment(processDate).format('MM');
            parameter.InvoiceYear =  moment(processDate).format('YYYY');
        }
        if(invoiceStatus){
            parameter.Invoiced = (invoiceStatus === 'Invoiced');
        }
        if(currency){
            parameter.Currency = currency;
        }
        if(airlineCode){
            parameter.AirlineCode = airlineCode;
        }
        const { dispatch } = this.props;
        let fromIndex;
        dispatch(apiActions.startRequest());
        if(pageNumber === undefined){
            pageNumber = 1;
            fromIndex = pageSize * (pageNumber -1);
        }else{
            fromIndex = pageSize * (pageNumber -1);
        }

        if (pageMode === appConstants.INVOICE_RECONCILIATION_PROCESS_MODE){
            if (pageNumberLock !== undefined){
                const invoicePaginated = billsByProcessRecords.slice(fromIndex, (pageSize + fromIndex));
                this.setState({ currentPage: pageNumber, reports: invoicePaginated });
                dispatch(apiActions.endRequest());
            }else{
                this.searchByProcessName(filterValues[0]);
                dispatch(apiActions.endRequest());
            }
            this.onScroll();
        }else{
             let payload =
                {
                    "PageSize": pageSize,
                    "From": fromIndex,
                    "Parameter": parameter
                };

            this.setState({formPayload : payload});
            commonService.getInvoiceReconciliation(payload)
                .then(res => {
                    if(res.status === appConstants.SUCCESS_RESPONSE) {
                        const invoice = res.response;
                        this.setState({ currentPage: pageNumber, TotalCount: invoice.TotalCount, reports: invoice.Results });
                        dispatch(apiActions.endRequest());
                    }
                    else if(res.status === appConstants.ERROR_RESPONSE){
                        this.notify(res.response, appConstants.NOTIFY_ERROR);
                        dispatch(apiActions.endRequest());
                    }
                    this.onScroll();
                });
        }
    };

    searchByProcessName = (activeBillSummary) => {
        const { pageSize } = this.state;
        const { dispatch } = this.props;
        if(activeBillSummary !== undefined){
            dispatch(apiActions.startRequest());
            commonService.getInvoiceReconciliationByProcessName(activeBillSummary.Id)
                .then(res => {
                    if(res.status === appConstants.SUCCESS_RESPONSE) {
                        const invoice = res.response;
                        const invoicePaginated = res.response.Results.slice(0, pageSize);
                        const filterValue = [{Id: activeBillSummary.Id, ProcessName: activeBillSummary.ProcessName, Name: activeBillSummary.ProcessName, type: 4}];
                        this.setState({processDate: '', selectedFilterMode: 4, filterOptions: this.state.invoiceReconciliationFiles, filterLabelKey: 'Id', filterValueKey: 'Name', pageMode: appConstants.INVOICE_RECONCILIATION_PROCESS_MODE,
                            filterValues: filterValue, currentPage: 1, TotalCount: invoice.TotalCount, billsByProcessRecords: invoice.Results, reports: invoicePaginated });
                        dispatch(apiActions.endRequest());
                    }
                    else if(res.status === appConstants.ERROR_RESPONSE){
                        this.notify(res.response, appConstants.NOTIFY_ERROR);
                        dispatch(apiActions.endRequest());
                    }
                    this.onScroll();
                });
        }else{
            /* Reset record to empty until Process name is selected */
            this.setState({ pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE, reports: [], TotalCount: 0});
        }

    };


    getInvoiceReconciliationFiles = () => {
        const payload = { PageSize: 1000, From: 0, Parameter: {} };
        commonService.getInvoiceReconciliationFiles(payload)
            .then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    let refinedResponse = res.response.Results.map(item => {
                        return {
                            Id: item.Id, FileId: item.FileId, ProcessDate: item.ProcessDate, BatchId: item.BatchId, ProcessName: item.ProcessName, Name: item.ProcessName, DateSupplied: item.DateSupplied, type: 4
                        }
                    });
                    this.setState({ invoiceReconciliationFiles: refinedResponse });
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                }
            });
    };

    generateInvoice = () => {
        this.resetForm();
        const { dispatch } = this.props;
        dispatch(apiActions.startRequest());

       commonService.generateInvoice(this.state.billSummaryId)
            .then(res => {
                let response = res.response.data;
                window.open(response.Source.InvoiceUrl, '_blank');
                dispatch(apiActions.endRequest());
                this.toggleInvoiceModal();
                this.search(this.state.currentPage);
            }).catch(
            err => {
                this.setState({invoiceError: err.response});
                dispatch(apiActions.endRequest());
            }
        )

    };

    toggleInvoiceModal = (payload) => {
        const invoiceId = (payload !== undefined) ? payload : null;
        const currGenerateInvoiceModalState = this.state.generateInvoiceModal;
        this.setState({billSummaryId : invoiceId, generateInvoiceModal: !currGenerateInvoiceModalState, modalClass: this.state.modalClass});
    };

    toggleInvoiceIssuerModal = () => {
        const currIssuerInvoiceModalState = this.state.issuerInvoiceModal;
        this.setState({ issuerInvoiceModal: !currIssuerInvoiceModalState, modalClass: this.state.modalClass});
    };

    handleFilterModeChange = (target) => {
        let currMode = target.id;
        const { invoiceReconciliationFiles, airlines,  statusFilterTypeOptions, currencyFilterTypeOptions } = this.state;
        this.setState({selectedFilterMode: currMode});
        switch (currMode){
            case 1:
                return this.setState({ filterOptions: airlines, filterLabelKey: 'Id', filterValueKey: 'Name', pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE});
            case 2:
                return this.setState({ filterOptions: statusFilterTypeOptions, filterLabelKey: 'Id', filterValueKey: 'Name', pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE});
            case 3:
                return this.setState({ filterOptions: currencyFilterTypeOptions, filterLabelKey: 'Id', filterValueKey: 'Name', pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE});
            case 4:
                return this.setState({ filterOptions: invoiceReconciliationFiles, filterLabelKey: 'Id', filterValueKey: 'Name', processDate: '', pageMode: appConstants.INVOICE_RECONCILIATION_PROCESS_MODE});
            default:
                return this.setState({ filterOptions: airlines, filterLabelKey: 'Id', filterValueKey: 'Name', pageMode: appConstants.INVOICE_RECONCILIATION_SEARCH_MODE});
        }
    };
    handleSelectedFilterValuesChange = (target) => {
        let currFilterValues = this.state.filterValues;
        let newValue = target.filter(x => !currFilterValues.includes(x));
        // let pageMode ;
        let removedValue = currFilterValues.filter(x => !target.includes(x));

        if(removedValue.length === 0){
            if(this.state.pageMode === appConstants.INVOICE_RECONCILIATION_PROCESS_MODE){
                //    Process mode selected
                currFilterValues = newValue;
            }else{
                let found = false;
                currFilterValues.forEach(function (item, key) {
                    if(item.type === 4){
                        currFilterValues.slice(key);
                    }else if(item.type === newValue[0].type){
                        currFilterValues[key] = newValue[0];
                        found = true;
                    }
                });
                if(!found){
                    target = target.filter(item => item.type !== 4);
                    currFilterValues = target;
                }
            }
            this.setState({filterValues: currFilterValues});
         }else{
            this.setState({filterValues: target});
        }
    };

    onScroll = () => {
        const positionOffset = document.body.offsetHeight - window.innerHeight - window.scrollY + 50;
        this.setState({ positionFromBottom: positionOffset });
     };

    handleReportDownload = () => {
        const  { dispatch } = this.props;
        dispatch(apiActions.startRequest());
        let { formPayload, pageMode, filterValues } = this.state;
         if(pageMode === appConstants.INVOICE_RECONCILIATION_PROCESS_MODE){
            formPayload.Parameter = { ProcessName: filterValues[0]["ProcessName"]}
        }
        commonService.downloadInvoiceReport(formPayload)
            .then((res) => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    let response = res.response.data;
                    window.open(response.File, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });

    };

    getInvoiceIssuers = (payload) => {
        const  { dispatch } = this.props;
        dispatch(apiActions.startRequest());
        commonService.getInvoiceIssuers(payload)
            .then((res) => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ invoiceIssuer: res.response.Results});
                    this.toggleInvoiceIssuerModal();
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });
    };

    handleDownload = () => {
        const {dispatch} = this.props;
        const {processDate, filterValues,} = this.state;
        let airlineCode, currency = false;

        let parameter = {};

        filterValues.map((item) => {
            if (item.type === 2 && item.Name === "Invoiced") {
                parameter.Invoiced = true;
            }else if (item.type === 2 && item.Name === "Not Invoiced") {
                parameter.Invoiced = false;
            }
            else if (item.type === 3) {
                //    Currency selected selected
                currency = item.Code;
            } else if (item.type === 4) {
                parameter.ProcessName = item.ProcessName;
            }
            else if (item.type === undefined) {
                //    Airline selected
                airlineCode = item.Code;
            }
            return true;
        });

        if (processDate) {
            parameter.InvoiceMonth = moment(processDate).format('MM');
            parameter.InvoiceYear = moment(processDate).format('YYYY');
        }
        if (currency) {
            parameter.Currency = currency;
        }
        if (airlineCode) {
            parameter.AirlineCode = airlineCode;
        }

        // console.log({parameter})
        dispatch(apiActions.startRequest());

        commonService.downloadInvoiceReconciliationReport(parameter)
            .then(res => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let response = res.response;
                    window.open(response.File, '_blank');
                    dispatch(apiActions.endRequest());
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            })
    };

    render() {
        const { requesting, pageRequesting } = this.props;
        const { pageMode, contentError, error, reports, fetchingMore, stopFetching, filterModes, selectedFilterMode, filterOptions, filterValueKey, filterLabelKey, filterValues, invoiceError, currentPage, TotalCount, pageSize, invoiceReconciliationFiles, invoiceIssuer, positionFromBottom } = this.state;
        return (
            <div className="view">
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        {(!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}
                        { (!contentError && !pageRequesting) &&
                        <CardBody className="table-responsive full">
                            {/*Form to Filter Dashboard*/}
                            <div className={"mb-2"}>
                                <InvoiceSearchPanel
                                    filters={filterModes}
                                    selectedFilterMode={selectedFilterMode}
                                    filterOptions={filterOptions}
                                    filterValues={filterValues}
                                    filterLabelKey={filterLabelKey}
                                    filterValueKey={filterValueKey}
                                    onFilterModeValueChange={this.handleFilterModeChange}
                                    onSelectedFilterValuesChange={this.handleSelectedFilterValuesChange}
                                    processDateChange={processDate => this.setState({ processDate })}
                                    pageMode={pageMode}
                                    onSearch={this.search}
                                />
                            </div>
                            {(!pageRequesting && error) &&
                            (
                                <ComponentPageError error={error}/>
                            )
                            }

                            {(!pageRequesting && !error && TotalCount > 1) &&
                            (
                                <Row>
                                    <Col md={4}>
                                        <h5 className="font-weight-normal">
                                            <ReportIcon size="22" color="#43a8df"/>&nbsp;{appHelpers.numberWithCommasOnly(TotalCount)} records matched
                                        </h5>
                                    </Col>
                                    <Col md={3}>
                                         <Button className="btn btn-avi-primary mb-2" onClick={this.handleDownload}>
                                            <DownloadIcon/>  Download
                                         </Button>
                                    </Col>
                                </Row>
                            )
                            }
                            {(!pageRequesting && !error && TotalCount === 1) &&
                            (
                                <Row>
                                    <Col md={4}>
                                        <h5 className="font-weight-normal mb-2">
                                            <ReportIcon size="22" color="#43a8df"/>&nbsp;{appHelpers.numberWithCommasOnly(TotalCount)} record matched
                                        </h5>
                                    </Col>
                                    <Col md={3}>
                                        <Button className="btn btn-avi-secondary d-flex justify-content-center mb-2" onClick={this.handleDownload}>
                                            <DownloadIcon/>  Download
                                        </Button>
                                    </Col>
                                </Row>
                            )
                            }
                            {(!pageRequesting  && !error && reports.length > 0)&&
                            (
                                <InvoiceTimeline positionFromBottom={positionFromBottom} getInvoiceIssuers={this.getInvoiceIssuers} invoiceReconciliationFiles={invoiceReconciliationFiles} searchByProcessName={this.searchByProcessName} pageDataCallback={this.search} currentPage={currentPage} handleReportDownload={this.handleReportDownload} reports={reports} toggleInvoiceModal={this.toggleInvoiceModal} pageSize={pageSize} totalCount={ TotalCount } />
                            )
                            }
                            {(!error && fetchingMore) &&
                            <h5 className="text-center mt-3">
                                Loading more...
                            </h5>
                            }
                            { (!error && stopFetching && reports.length !== 0) &&
                            <h5 className="text-center mt-3">
                                End of records
                            </h5>
                            }
                            {!error && (reports !== false) && (!pageRequesting && reports.length === 0) &&
                            <PageEmptyContent message='No record match your search!'/>

                            }

                            <Modal size={'sm'} isOpen={this.state.generateInvoiceModal} toggle={this.toggleInvoiceModal} className={this.state.modalClass}>
                                <ModalHeader toggle={this.toggleInvoiceModal}> Invoice</ModalHeader>
                                <ModalBody>
                                    <div className="text-center">
                                        <CheckIcon size="50"/>
                                    </div>
                                    {
                                        invoiceError &&
                                        <div className="alert alert-danger text-center">{invoiceError}</div>
                                    }
                                    <h5 className='text-center mb-3'>Are you sure you want to create this invoice?</h5>
                                </ModalBody>
                                <ModalFooter>
                                    <Button className="btn-avi-primary" disabled={ requesting } onClick={this.generateInvoice} > Generate </Button>{' '}
                                    <Button color="secondary" disabled={ requesting } onClick={this.toggleInvoiceModal}> Cancel </Button>{' '}
                                </ModalFooter>
                            </Modal>
                            {/*Issuer Modal */}
                            <Modal isOpen={this.state.issuerInvoiceModal} toggle={this.toggleInvoiceIssuerModal} className={this.state.modalClass}>
                                <ModalHeader toggle={this.toggleInvoiceIssuerModal}> Issuers</ModalHeader>
                                <ModalBody>
                                    <InvoiceIssuerTable data={ invoiceIssuer }/>
                                 </ModalBody>
                                <ModalFooter>
                                     <Button color="secondary" disabled={ requesting } onClick={this.toggleInvoiceIssuerModal}> Cancel </Button>{' '}
                                </ModalFooter>
                            </Modal>
                        </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { modal, alert, airlinesCarriers, invoice } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        modal,
        alert,
        airlinesCarriers,
        invoice,
    };
}
export default connect(mapStateToProps)(InvoiceReconciliationViewContent);



// WEBPACK FOOTER //
// ./src/views/invoice/view-content.js